import { render, staticRenderFns } from "./SystemScoreDescription.vue?vue&type=template&id=38faf7be&scoped=true&"
import script from "./SystemScoreDescription.vue?vue&type=script&lang=js&"
export * from "./SystemScoreDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38faf7be",
  null
  
)

export default component.exports